var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pazienti-list-component',{attrs:{"pathResource":_vm.pathResource,"utente":_vm.utente,"fonte":_vm.fonte}})}
var staticRenderFns = []

export { render, staticRenderFns }